import { render, staticRenderFns } from "./familyMember.vue?vue&type=template&id=094999c6&scoped=true&"
import script from "./familyMember.vue?vue&type=script&lang=js&"
export * from "./familyMember.vue?vue&type=script&lang=js&"
import style0 from "./familyMember.vue?vue&type=style&index=0&id=094999c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094999c6",
  null
  
)

export default component.exports